



  class subscriptionbtn {
    constructor(){
        // window.onscroll = function() {this.scrollFunction()};
        window.addEventListener("scroll",()=>{
            this.scrollFunction()
        })
        // When the user clicks on the button, scroll to the top of the document
        document.getElementById("backtotop").addEventListener("click",(event)=>{
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
            document.getElementById("backtotop").style.display = "none";
        });

   
   }
   scrollFunction() {
    let mybutton = document.getElementById("backtotop");
    mybutton.style.display = "none";
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      mybutton.style.display = "inline-flex";
    } else {
      mybutton.style.display = "none";
    }
  }
     
  }
  new subscriptionbtn();

